import * as React from 'react';

import navigate from 'libs/router/navigate';

import { FormActions } from 'components/form';
import ActionButton from 'components/buttons/action-button/ActionButton';
import SVGIcon from 'components/svg-icon/SVGIcon';

import { __t, applyTranslations } from 'utils/language';
import { isLessThanDesktop } from 'utils/mobile-app';

import './profile-boost-complete.scss';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('./profile-boost-complete.i18n.json'));

const COMMON_MSG_KEY = 'collabary_common';
const MSG_KEY = 'profile_boost_complete';

const ProfileBoostComplete = (): JSX.Element => {
  const handleFinish = (): void => {
    navigate.to('/');
  };

  const renderActions = (): React.ReactNode => (
    <FormActions align="center">
      <ActionButton
        color="primary"
        className="profile-boost-complete__button"
        onClick={handleFinish}
      >
        {__t(`${COMMON_MSG_KEY}.action_button.close`)}
      </ActionButton>
    </FormActions>
  );

  const size = isLessThanDesktop() ? 98 : 196;

  return (
    <div className="profile-boost-complete">
      <div className="profile-boost-complete__heading">
        {__t(`${MSG_KEY}.heading`)}
      </div>
      <div className="profile-boost-complete__image">
        <SVGIcon
          name="profile-creation-step-finished"
          width={size}
          height={size}
        />
      </div>
      {renderActions()}
    </div>
  );
};

export default ProfileBoostComplete;
